import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getFormName } from '../../utils/nameFormat';
export const sortFormFieldsStmtInstruction = `
#### Sort fields in form
- Syntax: \`sort form fields in <form_name>: <field_name>, <field_name>, ... ;\`
- Example: \`sort form fields in ${getFormName('Product')}: name, description, category;\`
`;
export const stmtSortFormFields = ({ formName, fieldNames }) => {
    return `sort form fields in ${formName}: ${fieldNames.join(', ')};`;
};
export const sortFormFieldsHandler = createStructureStatementHandler({
    type: 'sort form fields',
    parse: line => {
        const match = /^sort (fields|form fields) in (?<formName>\w+): (?<fieldNames>[\w\s.,]+)/.exec(line);
        return match?.groups
            ? {
                type: 'sort form fields',
                formName: match.groups.formName,
                fieldNames: match.groups.fieldNames.split(',').map(it => it.trim()),
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.sortFormFields({
                formName: stmt.formName,
                fieldNames: stmt.fieldNames,
            });
        });
    },
});
//# sourceMappingURL=SortFormFieldsStmt.js.map